import { useIntl } from 'react-intl';

export const waitingDaysLabelFormatter = (value: string, intl: ReturnType<typeof useIntl>) => {
    if (value === '<1') {
        return intl.formatMessage(
            {
                id: 'pudo-dashboard.waiting-days-label-singular',
                defaultMessage: 'Waiting {value} day'
            },
            { value }
        );
    }
    return intl.formatMessage(
        {
            id: 'pudo-dashboard.waiting-days-label-plural',
            defaultMessage: 'Waiting {value} days'
        },
        { value }
    );
};
